<template>
  <Modal
    v-model="_value"
    width="500"
    title='HIK设置里程'
    @on-visible-change="visibleChange"
    ok-text="发送"
    @on-ok="onOk">

    <Form :label-width="180">
      <FormItem prop="alarm" label="行驶里程数（单位：1公里）：">
        <InputNumber :min="0" :step="0.1" style="display: inline-block; width: 200px;" v-model="device.mileage"
                     placeholder="请输入行驶里程数">
        </InputNumber>
      </FormItem>
    </Form>
  </Modal>
</template>
<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'hiksetmileagemodal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null,
    businessUserId: null
  },
  data () {
    return {
      device: {
        mileage: 0
      }
    }
  },
  methods: {
    ...mapActions([
      'ShortMessageServ_Send'
    ]),
    onOk () {
      let content = 'SpeedMileage:' + this.device.mileage * 1000 + ';A!!!'

      store.dispatch('NetCommandServ_SendCommand', {
        params: { id: this._initValue, content: content, urgent: false }
      }).then(() => {
        this.$Message.success('发送成功')
      }).catch(err => {
        this.$Message.error(err)
      })
    },
    onCleanDriverCardParams () {
      this.device.mileage = null
    },
    visibleChange (val) {
      if (val) {
        this.device.mileage = null
      }
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _businessUserId: {
      get () {
        return this.businessUserId
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    rules () {
      return {
        name: this.nameRules,
        phoneNum: this.phoneNumRules
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
